import React from "react";
import TextInput from "../../../core/form/TextInput";

let ClientEmailField = (props) => {

    return <TextInput
        type='email'
        name='email'
        label='form.client.email'
        required={true}
        {...props}
    />

}

export default ClientEmailField